import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Search, TrendingUp, Trophy, Users } from 'lucide-react';

const Home = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/stats/${search.trim()}`);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="pt-[calc(var(--nav-height)+4rem)] pb-20 px-8 max-w-6xl mx-auto">
      <motion.div 
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="text-center"
      >
        <motion.h1 variants={itemVariants} className="text-6xl md:text-8xl font-black mb-6">
          TRACK YOUR <br />
          <span className="gradient-text">VICTORIES.</span>
        </motion.h1>
        
        <motion.p variants={itemVariants} className="text-xl text-white/50 max-w-2xl mx-auto mb-12">
          Consultez vos statistiques Battle Royale, découvrez la boutique du jour et suivez les dernières actualités de Fortnite.
        </motion.p>

        <motion.form 
          variants={itemVariants}
          onSubmit={handleSearch} 
          className="relative max-w-2xl mx-auto mb-20"
        >
          <input
            type="text"
            placeholder="Entrez votre pseudo Epic Games..."
            className="w-full bg-white/5 border border-white/10 rounded-2xl py-6 px-16 text-xl focus:outline-none focus:border-purple-500/50 transition-all shadow-2xl backdrop-blur-md"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Search className="absolute left-6 top-1/2 -translate-y-1/2 w-6 h-6 text-white/40" />
          <button 
            type="submit"
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-purple-600 hover:bg-purple-500 text-white px-8 py-3 rounded-xl font-bold transition-all shadow-lg shadow-purple-600/20"
          >
            Rechercher
          </button>
        </motion.form>

        <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="glass-card p-8 text-left">
            <Trophy className="w-10 h-10 text-yellow-500 mb-4" />
            <h3 className="text-xl mb-2">Stats Précises</h3>
            <p className="text-white/40 text-sm">Récupérez vos victoires, kills, ratios et temps de jeu en temps réel.</p>
          </div>
          <div className="glass-card p-8 text-left">
            <TrendingUp className="w-10 h-10 text-blue-500 mb-4" />
            <h3 className="text-xl mb-2">Boutique du Jour</h3>
            <p className="text-white/40 text-sm">Visualisez tous les skins et objets disponibles dans la boutique actuelle.</p>
          </div>
          <div className="glass-card p-8 text-left">
            <Users className="w-10 h-10 text-purple-500 mb-4" />
            <h3 className="text-xl mb-2">Communauté</h3>
            <p className="text-white/40 text-sm">Suivez les actualités et les mises à jour majeures du jeu.</p>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Home;
